<template>
  <ion-app>
    <div class="ion-page">
      <ion-header>
        <ion-toolbar color="dark" mode="ios">
          <ion-buttons mode="ios">
            <ion-back-button></ion-back-button>
          </ion-buttons>
          <ion-title>Self Order</ion-title>
        </ion-toolbar>
      </ion-header>

      <ion-content v-if="isReject" class="ion-padding ion-text-center">
        <div class="reject-container">
          <div>
            <!-- Animasi X -->
            <div class="reject-wrapper">
              <div class="crossmark-wrapper">
                <div class="cross cross-left"></div>
                <div class="cross cross-right"></div>
              </div>
            </div>

            <h2 class="reject-title">Order Ditolak</h2>
            <p class="reject-subtitle">{{ rejectReason }}</p>
            <p class="reject-subtitle">Transaksi gagal. Silakan coba lagi atau pilih product lain.</p>
          </div>

          <ion-button class="reject-btn" expand="block" color="danger" @click="goToOutlet">
            Kembali ke Menu
          </ion-button>
        </div>
      </ion-content>

      <ion-content v-else class="waiting-content">
        <div class="page-container">

          <div class="main-content">
            <!-- Icon Section -->
            <div class="icon-section">
              <div class="icon-circle">
                <ion-icon :icon="timeOutline" class="custom-clock-icon"></ion-icon>
              </div>
            </div>

            <!-- Header Text -->
            <div class="text-section">
              <h1 class="page-title">Kami Sedang Mengecek Pesanan Anda</h1>
              <p class="page-subtitle">
                Kasir kami sedang memastikan ketersediaan stok. Proses ini biasanya 1-5 menit.
              </p>
            </div>

            <!-- Timer Card -->
            <div class="timer-card">
              <span class="timer-label">PESANAN AKAN DIBATALKAN OTOMATIS</span>
              <span class="timer-value">{{ formattedTime }}</span>
            </div>

            <!-- WhatsApp Card -->
            <div class="whatsapp-card" v-show="!disabledWaButton">
              <div class="wa-content">
                <h3 class="wa-title">Jangan takut ketinggalan info</h3>
                <p class="wa-subtitle">
                  Biar gak nunggu lama, kami akan kirim pesan saat stok dikonfirmasi.
                </p>
                <button class="wa-button" @click="sendWaNotification">
                  <ion-icon :icon="logoWhatsapp" class="wa-icon"></ion-icon>
                  Ingatkan Saya via WhatsApp
                </button>
              </div>
            </div>
          </div>

          <!-- Bottom Section -->
          <div class="bottom-section">
            <button class="cancel-button" @click="cancelOrder" :disabled="isLoading">
              <ion-spinner v-if="isLoading" name="crescent"></ion-spinner>
              <span v-else>BATALKAN PESANAN</span>
            </button>

            <div class="footer-info">
              <ion-icon :icon="informationCircleOutline" class="info-icon"></ion-icon>
              <span>HALAMAN INI AKAN TERUPDATE OTOMATIS</span>
            </div>
          </div>

        </div>
      </ion-content>
    </div>
    <wa-notif-modal v-show="!disabledWaButton" :isOpenModal="isOpenModal" @closeModal="closeModal" />
  </ion-app>
</template>

<script>
/* eslint-disable */
import { useOutletStore } from "@/stores/outlet"
import { IonApp, IonBackButton, IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonImg, IonSpinner, IonTitle, IonToolbar, alertController, loadingController } from "@ionic/vue";
import axios from "axios";
import { storage, STORAGE_KEYS } from "@/utils/storage";
import { logoWhatsapp, timeOutline, informationCircleOutline } from "ionicons/icons";
import waNotifModal from "../components/waNotifModal.vue"

export default {
  components: {
    IonApp,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonBackButton,
    IonTitle,
    IonContent,
    IonButton,
    IonImg,
    IonSpinner,
    IonIcon,
    waNotifModal
  },
  setup() {
    return { logoWhatsapp, timeOutline, informationCircleOutline };
  },
  data() {
    return {
      isOpenModal: false,
      timeLeft: 420,
      timer: null,
      isLoading: false,
      checkStatusTimer: null,
      isReject: false,
      rejectReason: "",
      firebaseToken: "",
      disabledWaButton: false,
    }
  },
  computed: {
    formattedTime() {
      const minutes = Math.floor(this.timeLeft / 60)
        .toString()
        .padStart(2, "0")
      const seconds = (this.timeLeft % 60).toString().padStart(2, "0")
      return `${minutes}:${seconds}`
    },
    outletStore() {
      return useOutletStore()
    }
  },
  created() {
    const outletStore = useOutletStore();
    if (outletStore.currentInvoice === "") {
      this.$router.replace({ name: "homePage" });
    }

    const deadline = storage.getOrderDeadline()
    if (deadline) {
      const now = Math.floor(Date.now() / 1000)
      const diff = parseInt(deadline, 10) - now;
      this.timeLeft = diff > 0 ? diff : 0;
    } else {
      const newDeadLine = Math.floor(Date.now() / 1000) + this.timeLeft;
      storage.setOrderDeadline(newDeadLine)
    }
  },
  methods: {
    closeModal() {
      this.isOpenModal = false
    },
    async sendWaNotification() {
      console.log("Mendaftarkan notifikasi WA...");
      const invoice = this.outletStore.currentInvoice;
      if (!invoice) {
        console.warn("Invoice is empty, redirecting to home...");
        this.goToOutlet()
        return;
      }
      const url = `${process.env.VUE_APP_BASE_URL}v1/orders/subscribe-request`;

      const myHeaders = new Headers();
      myHeaders.append("Public-Key", `${process.env.VUE_APP_PUBLIC_KEY}=`);
      // Tambahkan Content-Type agar server mengenali JSON body
      myHeaders.append("Content-Type", "application/json");

      const body = {
        order_id: invoice
      };

      const requestOptions = {
        method: "POST",
        body: JSON.stringify(body),
        headers: myHeaders,
      };

      try {
        const res = await fetch(url, requestOptions);
        if (res.ok) {
          const result = await res.json();
          const whatsappUrl = result.data.whatsapp_url;

          if (whatsappUrl) {
            window.open(whatsappUrl, '_blank');
          }
        } else {
          console.error("Gagal mendapatkan link WhatsApp, status:", res.status);
          this.goToOutlet()
        }
      } catch (error) {
        console.error("Error:", error);
      }
    },
    goToOutlet() {
      const id = this.$route.params.id;
      this.$router.push(`/${id}`)
    },
    async checkTransactionStatus() {
      this.checkStatusTimer = setInterval(async () => {
        const invoice = this.outletStore.currentInvoice
        const url = `${process.env.VUE_APP_BASE_URL}v2/transaction/${invoice}`

        const myHeaders = new Headers();
        myHeaders.append("Public-Key", `${process.env.VUE_APP_PUBLIC_KEY}=`);


        const requestOptions = {
          method: "GET",
          headers: myHeaders,
        };

        const res = await fetch(url, requestOptions)
        if (res.ok) {
          const data = await res.json()
          console.log(`show wa badge -> ${data.data.customer.subscription.whatsapp.active}`)
          if (data.data.customer.subscription.whatsapp.active) {
            this.disabledWaButton = true;
          }

          if (data.data.status === "accept") {
            if (storage.getLastPayment() === null) {
              this.createPayment()
            } else {
              const data = storage.getLastPayment()
              const paymentType = data?.data?.payment_info?.type || ""
              if (paymentType === "link") {
                const payUrl = data.data.payment_info.value
                window.location.href = payUrl
              } else if (paymentType === "qris")  {
                const id = this.$route.params.id;
                this.$router.push(`/${id}/order/payment/qris/code`)
              }else{
                this.createPayment()
              }
            }
            clearInterval(this.checkStatusTimer)
          }
          if (data.data.status === "reject" || data.data.status === "cancel") {
            this.isReject = true;
            storage.removeMultiple([
              STORAGE_KEYS.ORDER_DEADLINE,
              STORAGE_KEYS.CURRENT_INVOICE
            ])
            this.rejectReason = data.data.reject_reason;

            setTimeout(() => {
              this.goToOutlet()
            }, 10000);

          }
        }
      }, 5000);
    },
    async createPayment() {
      const invoice = this.outletStore.currentInvoice
      const url = `${process.env.VUE_APP_BASE_URL}v2/transaction/${invoice}/payment`

      const payload = new URLSearchParams({
        type: "qris",
        id: "qris",
      })

      const loading = await loadingController.create({
        message: 'Menyiapkan kode QRIS pembayaran...',
        spinner: 'circles',
      });
      await loading.present();

      try {
        const res = await axios.post(url, payload, {
          headers: {
            "Public-Key": `${process.env.VUE_APP_PUBLIC_KEY}=`,
            "Content-Type": "application/x-www-form-urlencoded",
          }
        })

        const data = res.data
        const paymentType = data.data.payment_info.type

        storage.setLastPayment(data)

        const id = this.$route.params.id;

        if (paymentType === "link") {
          const payUrl = data.data.payment_info.value
          window.location.href = payUrl
        } else {
          this.$router.push(`/${id}/order/payment/qris/code`)
        }
      } catch (err) {
        console.error("Create payment error:", err)
        const alert = await alertController.create({
          header: 'Koneksi Gagal',
          message: 'Gagal menyiapkan pembayaran. Silakan periksa koneksi internet Anda dan coba lagi.',
          buttons: [
            {
              text: 'Coba Lagi',
              handler: () => {
                this.createPayment();
              }
            },
            {
              text: 'Tutup',
              role: 'cancel',
              handler: () => {
                this.goToOutlet();
              }
            }
          ]
        });
        await alert.present();
      } finally {
        await loading.dismiss();
      }
    },
    startTimer() {
      this.timer = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--
        } else {
          clearInterval(this.timer)
          // Pass bypassApi = true to skip calling the PUT status API on automatic cancellation
          this.performCancellation(true)
        }
      }, 1000)
    },
    async cancelOrder() {
      const alert = await alertController.create({
        header: 'Batalkan Pesanan?',
        message: 'Apakah Anda yakin ingin membatalkan pesanan ini?',
        buttons: [
          {
            text: 'Tidak',
            role: 'cancel',
            cssClass: 'secondary',
          },
          {
            text: 'Ya, Batalkan',
            handler: () => {
              this.performCancellation()
            },
          },
        ],
      });

      await alert.present();
    },
    async performCancellation(bypassApi = false) {
      this.isLoading = true

      const invoice = this.outletStore.currentInvoice
      const url = `${process.env.VUE_APP_BASE_URL}v2/transaction/${invoice}/status`

      const myHeaders = new Headers();
      myHeaders.append("Public-Key", `${process.env.VUE_APP_PUBLIC_KEY}=`);

      const body = new URLSearchParams({
        status: "cancel"
      })

      const requestOptions = {
        method: "PUT",
        body: body,
        headers: myHeaders,
      };

      if (bypassApi) {
        console.log("Automatic cancellation triggered: Bypassing PUT API call")
      } else {
        const res = await fetch(url, requestOptions)

        if (res.ok) {
          const data = await res.json()
          console.log(data)
        }
      }
      storage.removeMultiple([
        STORAGE_KEYS.ORDER_DEADLINE,
        STORAGE_KEYS.CURRENT_INVOICE
      ])
      this.isLoading = false;
      const id = this.$route.params.id;
      this.$router.push(`/${id}`)
    },
  },
  async mounted() {
    if (!this.outletStore.currentInvoice) {
      console.warn("No active transaction ID found, redirecting to home...")
      this.goToOutlet()
      return
    }
    setTimeout(() => {
      this.isOpenModal = true
    }, 500);
    this.startTimer()
    this.checkTransactionStatus()
  },
  beforeUnmount() {
    if (this.timer) {
      clearInterval(this.timer)
    }
    if (this.checkStatusTimer) {
      clearInterval(this.checkStatusTimer)
    }
  }
}
</script>

<style scoped>
.waiting-content {
  --background: #fcfcfc;
}

.page-container {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  padding: 1.5rem 1.25rem;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  color: #333;
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* === Icon Section === */
.icon-section {
  margin-bottom: 2rem;
  margin-top: 1rem;
}

.icon-circle {
  width: 80px;
  height: 80px;
  background-color: #FFF8D1;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-clock-icon {
  font-size: 40px;
  color: #D9833B;
  --ionicon-stroke-width: 40px;
}

/* === Text Section === */
.text-section {
  text-align: center;
  margin-bottom: 2rem;
}

.page-title {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
  color: #2D3748;
}

.page-subtitle {
  font-size: 0.9rem;
  color: #718096;
  margin: 0;
  line-height: 1.5;
  padding: 0 1rem;
}

/* === Timer Card === */
.timer-card {
  width: 100%;
  background-color: #F4F5F7;
  border-radius: 12px;
  padding: 1.5rem 1rem;
  text-align: center;
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.timer-label {
  font-size: 0.75rem;
  color: #718096;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.5rem;
}

.timer-value {
  font-size: 2.5rem;
  font-weight: 800;
  color: #D9833B;
  font-variant-numeric: tabular-nums;
  line-height: 1.1;
}

/* === WhatsApp Card === */
.whatsapp-card {
  width: 100%;
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  /* Soft shadow */
  margin-bottom: 2rem;
  border: 1px solid #f0f0f0;
}

.wa-content {
  text-align: left;
}

.wa-title {
  font-size: 1rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
  color: #1A202C;
}

.wa-subtitle {
  font-size: 0.85rem;
  color: #4A5568;
  margin: 0 0 1.25rem 0;
  line-height: 1.4;
}

.wa-button {
  background: #25D366;
  color: white;
  border: none;
  border-radius: 50px;
  width: 100%;
  padding: 14px;
  font-size: 0.95rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(37, 211, 102, 0.3);
  transition: transform 0.1s active;
}

.wa-button:active {
  transform: scale(0.98);
}

.wa-icon {
  font-size: 1.4rem;
}

/* === Bottom Section === */
.bottom-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: auto;
  gap: 1rem;
  padding-bottom: 1rem;
}

.cancel-button {
  width: 100%;
  background: transparent;
  border: 2px solid #D9833B;
  border-radius: 12px;
  padding: 14px;
  color: #D9833B;
  font-weight: 700;
  font-size: 0.9rem;
  text-transform: uppercase;
  cursor: pointer;
  letter-spacing: 0.05em;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cancel-button:disabled {
  opacity: 0.5;
}

.footer-info {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  color: #A0AEC0;
  font-size: 0.7rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.info-icon {
  font-size: 0.9rem;
}

/* === Reject Styles === */
.reject-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  text-align: center;
}

.reject-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.crossmark-wrapper {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: #f44336;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  animation: pop 0.6s ease-out forwards;
  box-shadow: 0 0 20px rgba(244, 67, 54, 0.5);
}

.cross {
  position: absolute;
  width: 50px;
  height: 5px;
  background: #fff;
  border-radius: 3px;
  transform: scale(0);
  animation: drawCross 0.6s ease forwards;
}

.cross-left {
  transform: rotate(45deg) scale(0);
  animation-delay: 0.4s;
}

.cross-right {
  transform: rotate(-45deg) scale(0);
  animation-delay: 0.6s;
}

@keyframes drawCross {
  to {
    transform: rotate(var(--rotate, 0)) scale(1);
  }
}

@keyframes pop {
  0% {
    transform: scale(0.5);
  }

  70% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}

.reject-title {
  margin-top: 16px;
  font-size: 22px;
  font-weight: bold;
  color: #f44336;
}

.reject-subtitle {
  margin: 8px 0 24px;
  font-size: 14px;
  color: #666;
  padding: 0 1rem;
}

.reject-btn {
  margin-top: auto;
}
</style>
